import { render, staticRenderFns } from "./agreeMentMove.vue?vue&type=template&id=b4121cb8&scoped=true"
import script from "./agreeMentMove.vue?vue&type=script&lang=js"
export * from "./agreeMentMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4121cb8",
  null
  
)

export default component.exports